<template>
    <div v-if="visible" style="background-color: #fff;width: 100%;display: flex;flex-direction: column;height: 100%;">
        <div
            style="position: relative; display: flex;align-items: center;justify-content: center;height: 48px;background: #fff;text-align: center;">
            <div style="font-size: 16px;font-weight: bold;color: #0F1A3A;">{{ title }}</div>
            <img v-if="ChargeState == '1'" src="@/assets/images/ic_chogndian_zhaungtai1@2x.png"
                style="width: 32px;height: 20px;margin-left: 4px;" alt="">
            <img v-if="Speed != '0'" src="@/assets/images/ic_zhaungtai3@2x.png"
                style="width: 32px;height: 20px;margin-left: 4px;" alt="">

            <img src="@/assets/images/icon_close@2x.png"
                style="width: 20px;height: 20px;position:absolute;right: 16px;top:16px;cursor: pointer;" alt=""
                @click="hide">
        </div>
        <div style="flex: 1;overflow: auto;">
            <el-tabs stretch v-model="activeName" @tab-click="handleClick">
                <el-tab-pane :label="$t('locateVehicle.车辆监控信息')" name="first">
                    <vehicle_monitor_info :current="current" :OilTypeID="vehicleInfo.oilTypeID_New" />

                </el-tab-pane>
                <el-tab-pane :label="$t('locateVehicle.报警故障信息')" name="second">
                    <vehicle_fault_info :info="vehicleInfo.manuID" />

                </el-tab-pane>
                <el-tab-pane :label="$t('locateVehicle.车辆基础信息')" name="third">
                    <vehicle_base_info :VID="vehicleInfo.nodeValue" />
                </el-tab-pane>

            </el-tabs>
        </div>
        <div
            style="height: 68px;width: 100%;;background: #FFFFFF;border: 1px solid #C5D0E2;display: flex;align-items: center;justify-content: space-around;">

            <el-button type="primary" plain @click="queryDashboard">
                {{ $t('locateVehicle.查看仪表盘') }}
            </el-button>

            <el-button type="primary" plain @click="sendMessage">
                {{ $t('locateVehicle.发送消息') }}
            </el-button>

            <el-button type="primary" plain @click="queryTrack">
                {{ $t('locateVehicle.查询轨迹') }}
            </el-button>

            <el-button type="primary" plain @click="queryVideo">
                {{ $t('locateVehicle.视频监控') }}
            </el-button>


        </div>
        <VehicleDashboard ref="vehicleDashboard" />

    </div>
</template>
<script>
import vehicle_monitor_info from "./vehicle_monitor_info"
import vehicle_fault_info from "./vehicle_fault_info"
import vehicle_base_info from "./vehicle_base_info"
import VehicleDashboard from "./VehicleDashboard.vue"
import { queryRealTimeVehicleInfo } from "@/http/vehicle";
import { convertDirection } from "@/utils/VehicleHelper"
export default {
    props: {


    },
    components: {
        vehicle_monitor_info,
        vehicle_fault_info,
        vehicle_base_info, VehicleDashboard
    },
    data() {
        return {
            title: "",
            activeName: 'first',
            visible: false,
            current: {
                Position: "-",//最后位置
                AccState: "-",//ACC状态
                Speed: "-",//车速
                SOC: "-",//SOC
                Mileage: "-",//总里程
                UpdateTime: "-",//更新时间
                OfflineDuration: "-",//离线时间
                DrivingRange: "-",//续航里程
                OilPercent: "-",//剩余油量
                TotalVoltage: "-",//总电压
                TotalElectric: "-",//总电流
                MotorSpeed: "-",//电机转速/发动机转速
                ChargeState: "-",//充电状态     
                Direction: "-",//方向
                OilConsume: "-",//瞬时油耗
                EngineSpped: "-",//发动机转速
            },
            ChargeState: "",
            Speed: "0",
            OilTypeID: 5,
            vehicleInfo: {

            },
            timer: undefined,
        };
    },
    watch: {
        visible(val) {
            if (!val) {
                this.$emit("hide")
                this.stopTimer();

            }
        }

    },
    //页面显示的时候触发定时器，关闭的时候关闭定时器
    mounted() {

    
    },
    beforeDestroy() {
        if(this.timer){
            clearInterval(this.timer);
            this.timer=null;
        }
    },

    methods: {
        stopTimer(){
            if(this.timer){
                clearInterval(this.timer);
                this.timer=null;
            }
        },
        show(
            CarNo,
            vehicleInfo,

        ) {
            // console.log(this.title)
            // console.log(CarNo)
            // console.log(this.visible)
            // console.log((this.title == CarNo && this.visible))
            if (this.title == CarNo && this.visible) {
                if(this.timer){
                    clearInterval(this.timer);
                    this.timer=null;
                }

                this.hide()
                return
            }
            this.vehicleInfo = vehicleInfo;
            this.title = CarNo;
            this.getVehicleInfo();
            if(!this.timer){
                this.timer = setInterval(() => {
                    this.getVehicleInfo();
                }, 15000);
            }

            this.visible = true;

        },
        hide() {
            this.visible = false;
        },
        queryDashboard() {
            //显示仪表盘
            this.$refs.vehicleDashboard.show(this.vehicleInfo.nodeValue);
        },
        sendMessage() {

            this.$bus.$emit("openRightDrawer", {
                command: "SingleVehicleMsg",
                vehicleInfo: this.vehicleInfo,
            });
        },

        queryVideo() {
            this.$bus.$emit("openRightDrawer", {
                command: "SingleVehicleVedioMonitor",
                vehicleInfo: this.vehicleInfo,
            });
        },
        queryTrack() {
            this.$bus.$emit("openRightDrawer", {
                command: "SingleVehicleTrack",
                vehicleInfo: this.vehicleInfo,
            });
        },
        handleClick(tab, event) {
            // console.log(tab, event);
        },
        ConvertChargeState(state) {
            switch (state) {
                case "1":
                    return this.$t('locateVehicle.停车充电');
                case "2":
                    return this.$t('locateVehicle.行驶充电');
                case "3":
                    return this.$t('locateVehicle.未充电');
                case "4":
                    return this.$t('locateVehicle.充电完成');
                default:
                    return "--";
            }
        },
        ConvertAccState(state) {
            if (state == undefined) return this.$t("public.unKnown");
            var result;
            if ((state & 1) != 0) result = this.$t("locateVehicle.acc_open");
            else result = this.$t("locateVehicle.acc_close");
            return result;
        },
        getVehicleInfo() {
            if (!this.vehicleInfo.nodeValue) return;
            queryRealTimeVehicleInfo({
                VID: this.vehicleInfo.nodeValue
            }).then(res => {
                // console.log(res)
                if (res) {
                    var item = {};

                    item.Position = res.Position || "--";
                    item.AccState = this.ConvertAccState(res.AccState);
                    item.Speed = res.AccState != 1 ? "0" : res.Speed;
                    this.Speed = item.Speed;

                    item.SOC = res.Soc || "--";
                    item.Mileage = res.Mileage || "--";
                    item.UpdateTime = res.UpdateTime;
                    //UpdateTime 去掉年份
                    if (item.UpdateTime)
                        item.UpdateTime = item.UpdateTime.substring(5);

                    item.OfflineDuration = res.OfflineDuration || "--";
                    item.DrivingRange = res.DrivingRange || "--";
                    item.OilPercent = res.OilPercent || "--";
                    if (res.OilPercent != "--" && res.OilPercent != "255") {

                        item.OilPercent = (parseFloat(res.OilPercent) * 0.4).toFixed(1);
                    }

                    item.TotalVoltage = res.TotalVoltage || "--";
                    item.TotalElectric = res.TotalElectric || "--";
                    //  if (this.OilTypeID == 5)
                    item.MotorSpeed = res.MotorSpeed || "--";
                    // else {
                    item.EngineSpped = res.EngineSpped || "--";

                    //   }
                    item.ChargeState = this.ConvertChargeState(res.ChargeState);
                    this.ChargeState = res.ChargeState;
                    item.Direction = convertDirection(res.Direction);
                    item.OilConsume = res.OilConsume || "--";


                    this.current = item;
                }
            }).catch(err => {
                console.log(err)
            })
        }
    },
    mounted() {

    }
};
</script>